import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureListComponent } from './feature-list/feature-list.component';
import { TextsModule } from '../texts/texts.module';
import { FeaturesComponent } from './features.component';

@NgModule({
  declarations: [FeatureListComponent,FeaturesComponent],
  imports: [CommonModule,TextsModule],
  exports: [FeatureListComponent,FeaturesComponent]
})
export class ListsModule { }
